'use strict';

require('../src/pop.less');

var continer = $('<div class="enhancer-fe-pop"></div>');
$('body').append(continer);

var pop = {
	show: function show(opt) {
		opt = opt || {};
		var option = $.extend(true, {
			mask: true,
			icon: '',
			close: false,
			title: '',
			content: 'content',
			timeout: 2500,
			autoClose: true
		}, opt || {});

		if (!option.footer && !('mask' in opt)) {
			option.mask = false;
		}

		var mask = option.mask ? '<div class="fe-pop-mask"></div>' : '';
		var close = option.close ? '<div class="fe-pop-close">&times</div>' : '';
		var icon = option.icon ? '<div class="fe-pop-icon pop-' + option.icon + '"></div>' : '';
		var title = option.title ? '<div class="fe-pop-title">' + option.title + '</div>' : '';
		var footer = option.footer ? '<div class="fe-pop-footer">\n\t\t\t\t\t\t' + Object.keys(option.footer).map(function (key) {
			return '<button class="enhancer-btn" data-callback="' + key + '">' + key + '</button>';
		}) + '\n\t\t\t\t\t</div>' : '';

		var html = mask + '\n\t\t\t<div class="fe-pop-wrap">\n\t\t\t\t' + close + '\n\t\t\t\t<div class="fe-pop-content-wrap">\n\t\t\t\t\t' + icon + '\n\t\t\t\t\t<div style="flex: 1;">\n\t\t\t\t\t\t' + title + '\n\t\t\t\t\t\t<div class="fe-pop-content ' + (footer ? 'fe-indent' : '') + '">' + option.content + '</div>\n\t\t\t\t\t\t' + footer + '\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t';

		continer.html(html).show();
		continer.off('click');
		continer.on('click', '.fe-pop-close', function (e) {
			pop.hide('close');
		});
		continer.on('click', '.fe-pop-footer button', function (e) {
			var key = $(e.target).data('callback');
			var callbak = option.footer[key];
			if (callbak && typeof callbak === 'function') {
				callbak.call(e.target, e);
				if (option.autoClose) {
					pop.hide('footer.' + key);
				}
			}
		});

		if (!option.footer && option.timeout) {
			setTimeout(function () {
				pop.hide('timeout');
			}, option.timeout);
		}
		this.option = option;
		if (opt.width) {
			continer.find('.fe-pop-wrap').width(opt.width);
		}
	},
	hide: function hide(from) {
		continer.hide();
		var onHide = this.option.onHide;

		if (onHide && typeof onHide === 'function') {
			onHide(from);
		}
	}
};

module.exports = pop;



//////////////////
// WEBPACK FOOTER
// ./~/@enhancer/fe-pop/build/index.js
// module id = 15
// module chunks = 0